import React from "react";
import BikeCompareLandingPage from "../../src/components/BikeCompare/BikeCompareLandingPage";

const Page = () => {
  return <BikeCompareLandingPage flavor="ebike" data-test="page-ebike-vergleich"/>;
};

export default Page;
